import './style.scss'
import utility from 'src/utils/utility'
import { useState } from 'react';
import { AppSpan, AppText, CustomContainer, FlexRow, GridContainer, ScreenContainer } from 'src/style';
import {ReactComponent as PlaneIcon} from 'src/assets/img/plane-icon.svg'
import {ReactComponent as MoviesIcon} from 'src/assets/img/movies-icon.svg'
import { ComingSoon, Flights, Movies } from 'src/component';


const Lifestyle: React.FC = () => {
    const [view, setView] = useState('lifestyle-selection')

    return (
        <>
            { view === 'lifestyle-selection' &&
                <ScreenContainer padding='2.5' topPadding='0'>
                    <CustomContainer
                        customRadius='28px 28px 0px 0px' borderColor='#EAECF0'
                        minHeight='100' mnHUnit='%' bgColor='#FCFCFC' padding='2'
                    >
                        <CustomContainer>
                            <AppSpan textSize='2.2' fontWeight='700'>Lifestyle</AppSpan>
                        </CustomContainer>
                        
                        {/* <CustomContainer topMargin='2'>
                            <AppSpan>Please select a preferred option</AppSpan>
                            <FlexRow 
                                gap='2' justifyContent='space-between' topMargin='1.5'
                                alignItems='stretch'
                                className='fund-account-options'
                            >
                                <GridContainer 
                                    width='49.5' sizeUnit='%' borderColor='#EAECF0'
                                    radius='0.8' minHeight='8' bgColor='#ffffff' 
                                    padding='2.5' topPadding='2' bottomPadding='2'
                                    onClick={() => setView('flights')}
                                >
                                    <FlexRow justifyContent='space-between' gap='1.5'>
                                        <AppSpan fontWeight='600' color='#101828' cursor='pointer'>Flights</AppSpan>
                                        <PlaneIcon className='icon-component' />
                                    </FlexRow>
                                </GridContainer>
                                <GridContainer 
                                    width='49.5' sizeUnit='%' borderColor='#EAECF0'
                                    radius='0.8' minHeight='8' bgColor='#ffffff' 
                                    padding='2.5' topPadding='2' bottomPadding='2'
                                    onClick={() => setView('movies')}
                                >
                                    <FlexRow justifyContent='space-between' gap='1.5'>
                                        <AppSpan fontWeight='600' color='#101828' cursor='pointer'>Movies</AppSpan>
                                        <MoviesIcon className='icon-component' />
                                    </FlexRow>
                                </GridContainer>
                            </FlexRow>
                        </CustomContainer> */}
                        <ComingSoon />
                    </CustomContainer>
                </ScreenContainer>
            }
            { view === 'flights' &&
                <Flights
                    back={() => setView('lifestyle-selection')} 
                />
            }
            { view === 'movies' &&
                <Movies
                    back={() => setView('lifestyle-selection')}
                />
            }
        </>
    );
}

export default utility.routeData('lifestyle', 'Lifestyle', <Lifestyle/>)